import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Subscribe.css';
import { useNavigate } from 'react-router-dom';
import { Menu, X } from "lucide-react";
const Subscribe = () => {
  const [openmenu, setopenmenu] = useState(false);
  const [msisdn, setMsisdn] = useState('');
  const [autoMsisdn, setAutoMsisdn] = useState('');
  const [language, setLanguage] = useState("en");
  const [status, setStatus] = useState(null);
  const navigate = useNavigate();

  const headerUrl = '/header';
  const redirectUrl = 'http://consent.hutch.lk/register-service/VQ%3D%3DCg%3D%3DdQ%3D%3D';
  const termsAndConditions='https://hutch.lk/vterms/'
   const translations = {
  en: {
    heading: "Quiz Fun for You!",
    description: "Unlock daily quizzes, boost your brain and enjoy — all at your fingertips!",
    subscribeLine: "Subscribe to QuizBox",
    priceInfo: "Daily access at just Rs. 6 + tax/daily",
    subscribe: "Subscribe",
    terms: "Terms & Conditions",
  },
  si: {
    heading: "ඔබ සදහා ප්‍රශ්නෝත්තර විනෝදය!",
    description: "දිනපතා ප්‍රශ්නෝත්තර විවෘත කර, ඔබගේ මනස වර්ධනය කරමින් විනෝද වන්න — සෑම දෙයක්ම ඔබේ ඇඟිලි තුඩු යටින්!",
    subscribeLine: "QuizBox සේවාවට දායක වන්න",
    priceInfo: "දිනකට රු.6 + බදු පමණක්",
    subscribe: "දායක වන්න",
    terms: "නියමයන් සහ කොන්දේසි",
  },
  ta: {
    heading: "உங்களுக்கான வினாடி வினா மகிழ்ச்சி!",
    description: "தினசரி வினாடி வினாக்கள், உங்கள் மூளை திறனை வளர்க்கவும் மகிழவும் — அனைத்தும் உங்கள் கையடக்கத்தில்!",
    subscribeLine: "QuizBox சேவைக்கு சந்தா எடுக்கவும்",
    priceInfo: "தினம் ரூ.6 + வரி மட்டும்",
    subscribe: "சந்தா எடுக்கவும்",
    terms: "விதிமுறைகள் மற்றும் நிபந்தனைகள்",
  },
};

  useEffect(() => {
    axios.get(headerUrl)
      .then(response => {
        const result = response?.data;
        console.log("HEADERS", result);
        const headerMsisdn = result?.msisdn;
        setStatus(result?.status);

        if (result?.status === 2 && headerMsisdn && /^\d{11}$/.test(headerMsisdn)) {
          setAutoMsisdn(headerMsisdn);
        }

        if (result?.status === 1) {
          alert("You are already subscribed!");
        }
      })
      .catch(error => {
        console.error('Error fetching headers:', error);
      });
  }, [navigate]);

  const handleSubscribe = () => {
    const finalMsisdn = autoMsisdn || ('94' + msisdn);

    if (status === 2) {
      // Redirect to consent URL for unsubscribed users
      window.location.href = redirectUrl;
      return;
    }

    if (!/^\d{11}$/.test(finalMsisdn)) {
      alert('Please enter a valid mobile number');
      return;
    }

    navigate('/otp', { state: { msisdn: finalMsisdn } });
  };

  return (
    <>
    <nav className='w-scree h-[80px] bg-purple-700 flex items-center justify-between px-8 py-5'>
       <div id="nleft"><img src="/images/logo.png" alt="" width={100}  /></div>
      <div id="nmid" className="flex flex-wrap justify-center overflow-hidden">
  <button
    className="bg-purple-500 text-white md:px-6 md:py-3 px-4 py-2 m-2 rounded-md md:text-base text-sm transition duration-200 hover:bg-purple-600 font-semibold"
    onClick={() => setLanguage("en")}
  >
    English
  </button>
  <button
    className="bg-purple-500 text-white md:px-6 md:py-3 px-4 py-2 m-2 rounded-md md:text-base text-sm transition duration-200 hover:bg-purple-600 font-semibold"
    onClick={() => setLanguage("si")}
  >
    සිංහල
  </button>
  <button
    className="bg-purple-500 text-white md:px-6 md:py-3 px-4 py-2 m-2 rounded-md md:text-base text-sm transition duration-200 hover:bg-purple-600 font-semibold"
    onClick={() => setLanguage("ta")}
  >
    தமிழ்
  </button>
</div>

       <div id="nright">
           <button onClick={()=>{setopenmenu(!openmenu)}} className='text-white'>
              {openmenu ? <X size={28} /> : <Menu size={28} />}
            </button>
       </div>
       {openmenu &&(
        <div className='h-100% w-[250px] bg-white absolute top-[84px] right-2 flex flex-col p-4 gap-2 rounded-md z-50 '>
          <button className='w-100 bg-gray-100 hover:text-white hover:bg-purple-600 text-2xl p-10 text-left font-semibold'>{translations[language].subscribe}</button>
          <button className='w-100 bg-gray-100 hover:text-white hover:bg-purple-600 text-2xl p-10 text-left font-semibold'>{translations[language].terms}</button>
        </div>
       )}
    </nav>
    <div className="subscribe-container p-20">
    

      <img src="/images/logo.png" alt="QuizBox Logo" className="subscribe-logo" />

      <div className="subscribe-card">
        <h1 className="subscribe-title">{translations[language].heading}</h1>
        <p className="subscribe-desc">
          {translations[language].description}
        </p>

        <p className="subscribe-highlight">{translations[language].subscribeLine}</p>
        <p className="subscribe-subtext">
          {translations[language].priceInfo}
        </p>

        {/* Show input if status === 0 */}
        {status === 0 && (
          <div className="prefix-input-wrapper">
            <span className="prefix">94</span>
            <input
              type="tel"
              placeholder="Enter your mobile number"
              value={msisdn}
              onChange={(e) => {
                const digitsOnly = e.target.value.replace(/\D/g, '');
                if (digitsOnly.length <= 9) setMsisdn(digitsOnly);
              }}
              className="subscribe-input"
            />
          </div>
        )}

        {/* Show Subscribe button if status is 0 or 2 */}
        {(status === 0 || status === 2) && (
          <button onClick={handleSubscribe} className="subscribe-button">
            Subscribe Now
          </button>
        )}
      </div>
      <div className="md:w-[500px] h-100% bg-white mt-5 rounded-3xl shadow-lg p-10 overflow-y-auto">
        <h1 className='text-center text-4xl font-bold pb-5'>Terms and Conditions</h1>
  <ul className="list-disc list-outside pl-6 space-y-3 text-black text-2xl  leading-relaxed">
    <li>
      <span className="text-purple-600 font-medium">
        By clicking on subscribe,
      </span>
      you agree to the following terms and conditions.
    </li>
    <li>
      New customers will be charged according to the selected pack from the
      date of activation.
    </li>
    <li>
      Your subscription will be automatically renewed until you cancel or
      unsubscribe.
    </li>
    <li>
      You can unsubscribe any time through the site by clicking on{" "}
      <span className="font-semibold text-purple-600">‘Profile’</span> icon then{" "}
      <span className="font-semibold text-purple-600">‘Deactivate’</span>.
    </li>
    <li>
      You must be more than{" "}
      <span className="font-semibold">18 years old</span> to use this service.
    </li>
    <li>
      If you are less than 18 years old, you{" "}
      <span className="font-semibold uppercase text-red-600">MUST</span>{" "}
      receive permission from the authorized person who pays your bill.
    </li>
    <li>Standard data browsing costs will be applied.</li>
    <li>
      For support, please contact us at
      <span className="font-medium text-purple-600"> support@digitizeconsultant.com</span>
    </li>
  </ul>
</div>

    </div>
    </>
  );
};

export default Subscribe;





// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import './Subscribe.css';
// import { useNavigate } from 'react-router-dom';

// const Subscribe = () => {
//   const [msisdn, setMsisdn] = useState('');
//   const [autoMsisdn, setAutoMsisdn] = useState('');
//   const [status, setStatus] = useState(null);
//   const navigate = useNavigate();

//   const headerUrl = '/header';
//   const redirectUrl = 'http://consent.hutch.lk/register-service/VQ%3D%3DCg%3D%3DdQ%3D%3D'
//   useEffect(() => {
//     axios.get(headerUrl)
//       .then(response => {
//         const result = response?.data;
//         console.log("HEADERS", result)
//         const headerMsisdn = result?.msisdn;
//         setStatus(result?.status);

//         if (result?.status === 2 && headerMsisdn && /^\d{11}$/.test(headerMsisdn)) {
//           setAutoMsisdn(headerMsisdn);
//           // Automatically redirect to OTP if MSISDN found but not subscribed
//           navigate('/otp', { state: { msisdn: headerMsisdn } });
//         }

//         if (result?.status === 1) {
//           alert("You are already subscribed!");
//         }
//       })
//       .catch(error => {
//         console.error('Error fetching headers:', error);
//       });
//   }, [navigate]);

//   const handleSubscribe = () => {
//     const finalMsisdn = autoMsisdn || ('94' + msisdn);
//     if (!/^\d{11}$/.test(finalMsisdn)) {
//       alert('Please enter a valid mobile number');
//       return;
//     }

//     navigate('/otp', { state: { msisdn: finalMsisdn } });
//   };

//   return (
//     <div className="subscribe-container">
//       <img src="/images/logo.png" alt="QuizBox Logo" className="subscribe-logo" />

//       <div className="subscribe-card">
//         <h1 className="subscribe-title">Quiz Fun Awaits!</h1>
//         <p className="subscribe-desc">
//           Unlock daily quizzes, boost your brain  and enjoy — all at your fingertips!
//         </p>

//         <p className="subscribe-highlight">Subscribe to QuizBox</p>
//         <p className="subscribe-subtext">
//           Daily access at just <strong>Rs. 6 + tax/daily</strong>
//         </p>

//         {/* Only show input if status is 0 (msisdn not found) */}
//         {status === 0 && (
//           <div className="prefix-input-wrapper">
//             <span className="prefix">94</span>
//             <input
//               type="tel"
//               placeholder="Enter your mobile number"
//               value={msisdn}
//               onChange={(e) => {
//                 const digitsOnly = e.target.value.replace(/\D/g, '');
//                 if (digitsOnly.length <= 9) setMsisdn(digitsOnly);
//               }}
//               className="subscribe-input"
//             />
//           </div>
//         )}

//         {/* Show button only if status === 0 (input required) */}
//         {status === 0 && (
//           <button onClick={handleSubscribe} className="subscribe-button">
//             Subscribe Now
//           </button>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Subscribe;


// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import './Subscribe.css';
// import { useNavigate } from 'react-router-dom';

// const Subscribe = () => {
//   const [msisdn, setMsisdn] = useState('');
//   const [autoMsisdn, setAutoMsisdn] = useState('');
//   const navigate = useNavigate();
//   const headerUrl = '/header';

//   useEffect(() => {
//     axios.get(headerUrl)
//       .then(response => {
//         const headerMsisdn = response?.data?.msisdn;
//         if (headerMsisdn && /^\d{11}$/.test(headerMsisdn)) {
//           setAutoMsisdn(headerMsisdn);
//         }
//       })
//       .catch(error => {
//         console.error('Error fetching headers:', error);
//       });
//   }, []);

//   const handleSubscribe = () => {
//     const finalMsisdn = autoMsisdn || ('94' + msisdn);
//     if (!/^\d{11}$/.test(finalMsisdn)) {
//       alert('Please enter a valid mobile number');
//       return;
//     }

// navigate('/otp', { state: { msisdn: finalMsisdn } });

//   };

//   return (
//     <div className="subscribe-container">
//       <img src="/images/logo.png" alt="QuizBox Logo" className="subscribe-logo" />

//       <div className="subscribe-card">
//         <h1 className="subscribe-title">Quiz Fun Awaits!</h1>
//         <p className="subscribe-desc">
//           Unlock daily quizzes, boost your brain, and win exciting rewards — all at your fingertips!
//         </p>

//         <p className="subscribe-highlight">Subscribe to QuizBox</p>
//         <p className="subscribe-subtext">
//           Daily access at just <strong>Rs. 6 + tax/daily</strong>
//         </p>

//         {autoMsisdn === '' && (
//           <div className="prefix-input-wrapper">
//             <span className="prefix">94</span>
//             <input
//               type="tel"
//               placeholder="Enter your mobile number"
//               value={msisdn}
//               onChange={(e) => {
//                 const digitsOnly = e.target.value.replace(/\D/g, '');
//                 if (digitsOnly.length <= 9) setMsisdn(digitsOnly);
//               }}
//               className="subscribe-input"
//             />
//           </div>
//         )}

//         <button onClick={handleSubscribe} className="subscribe-button">
//           Subscribe Now
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Subscribe;


// live 
// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import './Subscribe.css';
// import { useNavigate } from 'react-router-dom';

// const Subscribe = () => {
//   const [msisdn, setMsisdn] = useState('');
//   const [autoMsisdn, setAutoMsisdn] = useState('');
//   const [status, setStatus] = useState(null);
//   const navigate = useNavigate();

//   const headerUrl = '/header';
//   const redirectUrl = 'http://consent.hutch.lk/register-service/VQ%3D%3DCg%3D%3DdQ%3D%3D';

//   useEffect(() => {
//     axios.get(headerUrl)
//       .then(response => {
//         const result = response?.data;
//         console.log("HEADERS", result);
//         const headerMsisdn = result?.msisdn;
//         setStatus(result?.status);

//         if (result?.status === 2 && headerMsisdn && /^\d{11}$/.test(headerMsisdn)) {
//           setAutoMsisdn(headerMsisdn);
//         }

//         if (result?.status === 1) {
//           alert("You are already subscribed!");
//         }
//       })
//       .catch(error => {
//         console.error('Error fetching headers:', error);
//       });
//   }, [navigate]);

//   const handleSubscribe = () => {
//     const finalMsisdn = autoMsisdn || ('94' + msisdn);

//     if (status === 2) {
//       // Redirect to consent URL for unsubscribed users
//       window.location.href = redirectUrl;
//       return;
//     }

//     if (!/^\d{11}$/.test(finalMsisdn)) {
//       alert('Please enter a valid mobile number');
//       return;
//     }

//     navigate('/otp', { state: { msisdn: finalMsisdn } });
//   };

//   return (
//     <div className="subscribe-container">
//       <img src="/images/logo.png" alt="QuizBox Logo" className="subscribe-logo" />

//       <div className="subscribe-card">
//         <h1 className="subscribe-title">Quiz Fun Awaits!</h1>
//         <p className="subscribe-desc">
//           Unlock daily quizzes, boost your brain and enjoy — all at your fingertips!
//         </p>

//         <p className="subscribe-highlight">Subscribe to QuizBox</p>
//         <p className="subscribe-subtext">
//           Daily access at just <strong>Rs. 6 + tax/daily</strong>
//         </p>

//         {/* Show input if status === 0 */}
//         {status === 0 && (
//           <div className="prefix-input-wrapper">
//             <span className="prefix">94</span>
//             <input
//               type="tel"
//               placeholder="Enter your mobile number"
//               value={msisdn}
//               onChange={(e) => {
//                 const digitsOnly = e.target.value.replace(/\D/g, '');
//                 if (digitsOnly.length <= 9) setMsisdn(digitsOnly);
//               }}
//               className="subscribe-input"
//             />
//           </div>
//         )}

//         {/* Show Subscribe button if status is 0 or 2 */}
//         {(status === 0 || status === 2) && (
//           <button onClick={handleSubscribe} className="subscribe-button">
//             Subscribe Now
//           </button>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Subscribe;





// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import './Subscribe.css';
// import { useNavigate } from 'react-router-dom';

// const Subscribe = () => {
//   const [msisdn, setMsisdn] = useState('');
//   const [autoMsisdn, setAutoMsisdn] = useState('');
//   const [status, setStatus] = useState(null);
//   const navigate = useNavigate();

//   const headerUrl = '/header';
//   const redirectUrl = 'http://consent.hutch.lk/register-service/VQ%3D%3DCg%3D%3DdQ%3D%3D'
//   useEffect(() => {
//     axios.get(headerUrl)
//       .then(response => {
//         const result = response?.data;
//         console.log("HEADERS", result)
//         const headerMsisdn = result?.msisdn;
//         setStatus(result?.status);

//         if (result?.status === 2 && headerMsisdn && /^\d{11}$/.test(headerMsisdn)) {
//           setAutoMsisdn(headerMsisdn);
//           // Automatically redirect to OTP if MSISDN found but not subscribed
//           navigate('/otp', { state: { msisdn: headerMsisdn } });
//         }

//         if (result?.status === 1) {
//           alert("You are already subscribed!");
//         }
//       })
//       .catch(error => {
//         console.error('Error fetching headers:', error);
//       });
//   }, [navigate]);

//   const handleSubscribe = () => {
//     const finalMsisdn = autoMsisdn || ('94' + msisdn);
//     if (!/^\d{11}$/.test(finalMsisdn)) {
//       alert('Please enter a valid mobile number');
//       return;
//     }

//     navigate('/otp', { state: { msisdn: finalMsisdn } });
//   };

//   return (
//     <div className="subscribe-container">
//       <img src="/images/logo.png" alt="QuizBox Logo" className="subscribe-logo" />

//       <div className="subscribe-card">
//         <h1 className="subscribe-title">Quiz Fun Awaits!</h1>
//         <p className="subscribe-desc">
//           Unlock daily quizzes, boost your brain  and enjoy — all at your fingertips!
//         </p>

//         <p className="subscribe-highlight">Subscribe to QuizBox</p>
//         <p className="subscribe-subtext">
//           Daily access at just <strong>Rs. 6 + tax/daily</strong>
//         </p>

//         {/* Only show input if status is 0 (msisdn not found) */}
//         {status === 0 && (
//           <div className="prefix-input-wrapper">
//             <span className="prefix">94</span>
//             <input
//               type="tel"
//               placeholder="Enter your mobile number"
//               value={msisdn}
//               onChange={(e) => {
//                 const digitsOnly = e.target.value.replace(/\D/g, '');
//                 if (digitsOnly.length <= 9) setMsisdn(digitsOnly);
//               }}
//               className="subscribe-input"
//             />
//           </div>
//         )}

//         {/* Show button only if status === 0 (input required) */}
//         {status === 0 && (
//           <button onClick={handleSubscribe} className="subscribe-button">
//             Subscribe Now
//           </button>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Subscribe;


// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import './Subscribe.css';
// import { useNavigate } from 'react-router-dom';

// const Subscribe = () => {
//   const [msisdn, setMsisdn] = useState('');
//   const [autoMsisdn, setAutoMsisdn] = useState('');
//   const navigate = useNavigate();
//   const headerUrl = '/header';

//   useEffect(() => {
//     axios.get(headerUrl)
//       .then(response => {
//         const headerMsisdn = response?.data?.msisdn;
//         if (headerMsisdn && /^\d{11}$/.test(headerMsisdn)) {
//           setAutoMsisdn(headerMsisdn);
//         }
//       })
//       .catch(error => {
//         console.error('Error fetching headers:', error);
//       });
//   }, []);

//   const handleSubscribe = () => {
//     const finalMsisdn = autoMsisdn || ('94' + msisdn);
//     if (!/^\d{11}$/.test(finalMsisdn)) {
//       alert('Please enter a valid mobile number');
//       return;
//     }

// navigate('/otp', { state: { msisdn: finalMsisdn } });

//   };

//   return (
//     <div className="subscribe-container">
//       <img src="/images/logo.png" alt="QuizBox Logo" className="subscribe-logo" />

//       <div className="subscribe-card">
//         <h1 className="subscribe-title">Quiz Fun Awaits!</h1>
//         <p className="subscribe-desc">
//           Unlock daily quizzes, boost your brain, and win exciting rewards — all at your fingertips!
//         </p>

//         <p className="subscribe-highlight">Subscribe to QuizBox</p>
//         <p className="subscribe-subtext">
//           Daily access at just <strong>Rs. 6 + tax/daily</strong>
//         </p>

//         {autoMsisdn === '' && (
//           <div className="prefix-input-wrapper">
//             <span className="prefix">94</span>
//             <input
//               type="tel"
//               placeholder="Enter your mobile number"
//               value={msisdn}
//               onChange={(e) => {
//                 const digitsOnly = e.target.value.replace(/\D/g, '');
//                 if (digitsOnly.length <= 9) setMsisdn(digitsOnly);
//               }}
//               className="subscribe-input"
//             />
//           </div>
//         )}

//         <button onClick={handleSubscribe} className="subscribe-button">
//           Subscribe Now
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Subscribe;
